'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var DISTANCE_CLASSES = exports.DISTANCE_CLASSES = {
  'flush': 'is--spaced--vertical--flush',
  'extra-small': 'is--spaced--vertical--xs',
  'small': 'is--spaced--vertical--sm',
  'medium': 'is--spaced--vertical--md',
  'large': 'is--spaced--vertical--lg',
  'extra-large': 'is--spaced--vertical--xl'
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.348/js/layout/DistanceConstants.js
// module id = 249
// module chunks = 0 1